import { StrapiErrorResponse } from '../interfaces'

export function isValidStrapiErrorResponse(
  response: unknown | StrapiErrorResponse
): response is StrapiErrorResponse {
  return (response as StrapiErrorResponse) !== undefined
}
